import { applyMiddleware, combineReducers, createStore } from "redux";
import reduxThunk from "redux-thunk";
import authentication from "../reducers/authentication";
import audit from "../reducers/audit";
import cam from "../reducers/cam";
import contactEvent from "../reducers/contactEvent";
import dhb from "../reducers/dhb";
import legalEntity from "../reducers/legalEntity";
import premises from "../reducers/premises";
import register from "../reducers/register";
import regulatoryInstrument from "../reducers/regulatoryInstrument";
import resources from "../reducers/resources";
import user from "../reducers/user";

const rootReducer = combineReducers({
  audit,
  authentication,
  cam,
  contactEvent,
  dhb,
  legalEntity,
  premises,
  register,
  regulatoryInstrument,
  resources,
  user
});

export default function configureStore() {
  return createStore(rootReducer, applyMiddleware(reduxThunk));
}
